var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Posts")]),_vm._v(" "),_c('div',_vm._l((_vm.posts),function(post){return _c('div',{key:post.dateAdded},[_vm._v("\n      "+_vm._s(_vm.$time(post.dateAdded).calendar())+"\n      "),_c('br'),_vm._v("\n      "+_vm._s(post.title)+"\n      "),_c('br'),_vm._v("\n      "+_vm._s(post.post)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-352e8022","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posts.vue
// module id = null
// module chunks = 